module.exports = __webpack_public_path__ + "static/img/nums.047eb459.png";